import CustomOfferPage from './CustomOfferPage'

export default CustomOfferPage